module.exports = __webpack_public_path__ + "assets/images/route-planning@2x-7fd30f38b3b2d9eb33eb33be3dcc87c1.png";